import React from 'react'

import { StatusMessage, Table } from '@driftt/dds'

import { SalesRepRows } from '../types'
interface ModalTableProps {
  tableData: SalesRepRows
}

const ModalTable = ({ tableData }: ModalTableProps) => {
  const getStatus = (status: boolean) => (
    <StatusMessage variant={status ? 'success' : 'error'}>{''}</StatusMessage>
  )

  return (
    <Table<SalesRepRows>
      rows={[tableData]}
      columns={[
        {
          header: 'Profile Photo',
          value: 'status.profilePhoto',
          cell: ({ status }) => getStatus(status.profilePhoto),
          size: 100,
          disableSort: true,
        },
        {
          header: 'Notifications',
          value: 'status.notificationSettings',
          cell: ({ status }) => getStatus(status.notificationSettings),
          size: 100,
          disableSort: true,
        },
        {
          header: 'Calendar',
          value: 'status.connectedCalendar',
          cell: ({ status }) => getStatus(status.connectedCalendar),
          size: 100,
          disableSort: true,
        },
        {
          header: 'Conference link',
          value: 'status.conferenceLink',
          cell: ({ status }) => getStatus(status.conferenceLink),
          size: 100,
          disableSort: true,
        },
      ]}
      disableBoxShadow
    />
  )
}

export default ModalTable
